export default __webpack_public_path__ + "static/media/okara-moz-logo-header.9ebf342e.png";